<template>
    <van-popup v-model:show="show" position="bottom" :overlay-style="{ overflow: 'hidden' }" :style="{
        minWidth: '100%',
        minHeight: '100%',
        color: '#fff',
        zIndex:'1998'

    }">
        <div class="popupContainer">
            <CustomHeader :text="$t('footer.bonus')" :isPopupCloseBackIcon="true" @close-popup="close"/>
            <div class="card_list"></div>
            <div v-for="(item, index) in dataSet?.promotionList" :key="index">
                <PromotionCard :itemData="item"
                    :un-claimed-count="activityCount(userStore.unreadActivityMsgList, item?.id)"
                    @openAgentPopup="openAgentPopup" @goToHome="close" @openPWA="openPWAPopup" />
            </div>
        </div>
    </van-popup>
</template>


<script setup lang="ts">
import { defineEmits, computed, PropType, defineProps } from 'vue'
import PromotionCard from './components/promotionCard.vue'
import { useI18n } from 'vue-i18n';
import { useUserStore } from '@/stores/user';
import { activityCount, PromotionData } from '@/view/promotion/supporrtScript';
import CustomHeader from '../components/common/customHeader.vue';
const userStore = useUserStore()
const { t } = useI18n();

const props = defineProps({
    dataSet: {
        type: Object as PropType<PromotionData>,
        required: true
    }
})

const show = computed({
    get: () => props.dataSet.show,
    set: (val) => emits('update:show', val)
})

const emits = defineEmits(['open', 'close', "openAgentPopup", "openPWAPopup", 'update:show'])
const open = () => {
    emits('open')
}
const close = () => {
    emits('close')
}
const openAgentPopup = () => {
    emits("openAgentPopup")
}

const openPWAPopup = () => {
    emits("openPWAPopup")
}

</script>
<style scoped>
.van-popup {
    background-color: #221b24;
    width: 100%;
    min-height: 90vh;
    padding-bottom: 100px;
    -ms-overflow-style: none;
    scrollbar-width: none;
    overflow-y: auto;
    z-index: 1998;
}

.card_list {
    padding: 30px 25px;
}

.van-popup::-webkit-scrollbar {
    display: none;
}

.header_container {
    height: 2.5rem;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background: #312734 !important;
    color: #ffa4d1;
    padding: 5px 12px;
    z-index: 1000;
}

.header_col img {
    opacity: 0.45;
    width: 30px;
}

.header_col {
    color: #ffa4d1;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
}
.van-overlay{
    z-index: 1997 !important;
}
</style>